<template>
  <div>
    <h1>Manage Check Lists</h1>

    <b-row>
      <b-col>
        <BaseSelector v-model="selectedStatus"
                      label="Select Lifecycle Status of Check List to Manage"
                      :v="$v.selectedStatus"
                      :options=statusOptions
        ></BaseSelector>
      </b-col>
    </b-row>

    <b-row v-if="selectedStatus">
      <b-col>
        <b-list-group>
          <b-row cols="1">
            <draggable :list="checklist.items">
              <b-list-group-item
                v-for="item in checklist.items"
                :key="item.sequence"
                v-model="item.sequence"
              >
                <b-row>
                  <b-col cols="2" md="auto">
                    <b-button variant="primary">
                      <b-icon icon="arrow-down-up"></b-icon>
                      re-order
                    </b-button>
                  </b-col>
                  <b-col cols="8">
                    <b-form-input type="text" v-model="item.text" :aria-label="item.text"/>
                  </b-col>
                  <b-col cols="2">
                    <b-button size="sm" class="mb-2" @click="removeList(item)">
                      <b-icon icon="dash-circle"></b-icon>
                      remove
                    </b-button>
                  </b-col>
                </b-row>
              </b-list-group-item>
            </draggable>
          </b-row>
        </b-list-group>
      </b-col>
    </b-row>

    <b-row v-if="selectedStatus" style="margin-top:20px; margin-bottom:20px;">
      <b-col>
        <b-input-group>
          <b-form-input v-model="newItem" v-on:keyup.enter="addToList" aria-label="Add new item"></b-form-input>

          <b-input-group-append>
            <b-button variant="primary" @click="addToList">
              <b-icon icon="plus-circle"></b-icon>
              Add
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>

    <b-row v-if="selectedStatus">
      <b-col>
        <b-button variant="primary" @click="saveCheckList">
          Save Check List
        </b-button>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import axios from 'axios';
import axiosRetry from 'axios-retry';
import {validationMixin} from 'vuelidate'
import {required} from 'vuelidate/lib/validators'
import {statusOptions} from '@/mixins/statusOptions.js'
import pageTitle from '@/mixins/pageTitle'
import BaseSelector from "@/components/BaseSelector.vue";
import draggable from "vuedraggable";

axiosRetry(axios, {
  retries: 3,
  retryDelay: axiosRetry.exponentialDelay
});

export default {
  title: 'Manage Check Lists',
  mixins: [validationMixin,
    statusOptions,
    pageTitle],
  components: {
    BaseSelector,
    draggable
  },
  data: () => ({
    selectedStatus: '',
    newItem: '',
    checklist: {},
  }),

  validations: {
    selectedStatus: {required},
  },

  watch: {
    selectedStatus() {
      this.loadChecklist()
    }
  },

  methods: {
    loadChecklist() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/checklist/config/${this.selectedStatus}`)
        .then(response => {
          this.checklist = response.data;
        })
    },

    addToList() {
      var item = {
        id: -1,
        text: this.newItem,
        seqeuence: 9999
      }
      this.checklist.items.push(item)
      this.newItem = null
    },

    saveCheckList() {
      axios.post(`${process.env.VUE_APP_API_BASE_URL}/checklist/config`,
        this.checklist)
        .then(response => {
          this.checklist = response.data;
        })
    },

    removeList(item) {
      axios.delete(`${process.env.VUE_APP_API_BASE_URL}/checklist/config/${item.id}`)
        .then(response => {
          const index = this.checklist.items.indexOf(item);
          this.checklist.items.splice(index, 1);
        })
    },
  }
}
</script>
